import { IFormulario } from "@/interfaces/IFormulario";
import { createAction } from "@reduxjs/toolkit";

const sync = createAction("FORMULARIO/sync", (items: IFormulario[]) => ({
  payload: { items },
}));

export const formularioAction = { sync };
